import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Column, Row } from 'components/common/layout'
import { StartupPositionCard } from 'components/startup/startup-position-card'
import { WholeStartupPosition } from 'types/common'
import { analytics } from 'infra/analytics'
import { useUser } from 'apis/hooks'

const sortPositions = (
  positions: WholeStartupPosition[],
  myPositionIds: number[],
) => {
  return positions.sort((a, b) => {
    const aIsInterested = a.isInterested
    const bIsInterested = b.isInterested

    if (aIsInterested && !bIsInterested) return -1
    if (!aIsInterested && bIsInterested) return 1

    const aIsMine = myPositionIds.includes(a.id)
    const bIsMine = myPositionIds.includes(b.id)

    if (aIsMine && !bIsMine) return -1
    if (!aIsMine && bIsMine) return 1

    return 0
  })
}

export const StartupPositionList: React.FC<{
  startupId: number
  positions: WholeStartupPosition[]
  columns: number
  limit: number
}> = ({ startupId, positions, columns, limit }) => {
  const { data: user } = useUser()
  const [extend, setExtend] = useState(false)
  const sortedPositions = user
    ? sortPositions(
        positions,
        user.interestedPositionTypes.map((item) => item.id),
      )
    : positions
  const _positions = extend ? sortedPositions : sortedPositions.slice(0, limit)

  useEffect(() => {
    setExtend(positions.length > limit ? false : true)
  }, [positions.length, limit])

  return (
    <Column style={{ gap: 12 }}>
      <PositionWrapper columns={columns}>
        {_positions.map((item) => (
          <div
            key={item.id}
            onClick={() =>
              analytics.track('compDetail_jsu_click_jobPost', {
                startupId: startupId,
                positionId: item.id,
                positionName: item.name,
              })
            }
          >
            <StartupPositionCard
              key={item.id}
              item={item}
              startupId={startupId}
            />
          </div>
        ))}
      </PositionWrapper>
      {!extend && (
        <MoreBtn onClick={() => setExtend(true)}>
          {positions.length - limit}개 채용 공고 더보기
        </MoreBtn>
      )}
    </Column>
  )
}

const PositionWrapper = styled(Column)<{ columns: number }>`
  gap: 12px;
  display: grid;
  grid-template-columns: repeat(${(p) => p.columns}, 1fr);
`

const MoreBtn = styled(Row)`
  padding: 10px;
  border-radius: 8px;
  justify-content: center;
  font-size: 14px;
  font-weight: ${(p) => p.theme.fontWeight.medium};
  border: 1px solid ${(p) => p.theme.color.line};
  color: ${(p) => p.theme.color.black2};
  cursor: pointer;
  :hover {
    background-color: ${(p) => p.theme.color.background3};
  }
`
